import { Element } from "@xmpp/xml"
import PubSubEventParser from "./PubSubEventParser"
import { Route2g } from "@/reducers/routes2gSlice"
import Route2gParser from "@/lib/route2gParser"

class Parser {
  static readonly NAMESPACE = "urn:slickshift:route:0"

  static parse(stanza: Element): Route2g | undefined {
    const routeElement = stanza?.getChild("route", this.NAMESPACE)

    if (!routeElement) return

    const lastUpdatedBy = routeElement.getAttr("last_updated_by")

    const stops = Route2gParser.parseRouteStops(routeElement) || []

    return {
      jid: stanza.getAttr("id"),
      lastUpdatedBy,
      stops,
      pastStops: Route2gParser.parsePastStops(routeElement),
    }
  }
}

export const Route2gPubSubParser = new PubSubEventParser<Route2g>(
  Parser.parse,
  Parser.NAMESPACE,
)
